import template from './contactsListItem.template.html';

export default {
  template,
  bindings: {
    contact: '=',
    labels: '=',
    onDelete: '&',
    onLabelsSelect: '&',
    onChange: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
      };

      ctrl.select = (data) => {
        ctrl.onChange({ data });
      };

      ctrl.contactDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.contactLabelsSelect = ($event, data) => {
        ctrl.onLabelsSelect({ event: $event, data });
      };

      ctrl.getLabel = (idLabel) => ctrl.labels.find((l) => l.id === idLabel);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
